export default function onAddPhoneNumber(index) {
    if (index === 0) {
        return [{ label: 'Primary Phone Number', required: true }, { label: 'Label' }];
    }
    return [{ label: 'Secondary Phone Number' }, { label: 'Label' }];
}
